const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const pad = (n: number): string => String(n).padStart(2, '0')

/**
 * Spec 040: the only place a feed time is formatted. Local `HH:MM` when the
 * instant is on the same local day as `now`, otherwise `D Mon HH:MM`.
 * An unparseable string is returned unchanged. No `Intl`.
 */
export function formatFeedTime(iso: string, now: number): string {
  const ms = Date.parse(iso)
  if (Number.isNaN(ms)) return iso
  const d = new Date(ms)
  const n = new Date(now)
  const hhmm = `${pad(d.getHours())}:${pad(d.getMinutes())}`
  const sameDay = d.getFullYear() === n.getFullYear() && d.getMonth() === n.getMonth() && d.getDate() === n.getDate()
  return sameDay ? hhmm : `${d.getDate()} ${MONTHS[d.getMonth()]} ${hhmm}`
}
